import React from 'react';
import SearchBlock from './SearchBlock.jsx';

export default class ModalServices extends React.Component {

    componentDidMount() {
        document.body.classList.add('overflow');
    }
    componentWillUnmount() {
        document.body.classList.remove('overflow');
    }

    changeHandler(item) {
        this.props.changeHandler(item);
        this.props.dismissHandler();
    }

    render() {
        let classes = "z-100 pin overflow-auto flex select-" + this.props.type + " modal modal-backdrop-light";
        return (
            <div className={classes} id={this.props.id}>
                <div className="modal__inner md:relative pin align-top m-auto h-50 justify-start flex flex-col">
                    <div className="modal__close" onClick={this.props.dismissHandler}><i className="fas fa-times"></i></div>
                    <div className="modal__ok md:hidden" onClick={this.props.dismissHandler}><i className="fas fa-check"></i></div>
                    <div className="modal__title">{ this.props.title }</div>
                    <div className="modal__subtitle">{ this.props.subtitle }</div>
                    <div className="flex flex-col modal__content h-full overflow-auto">
                        <SearchBlock
                            placeholder={trans.add_more_services}
                            addServiceHandler={this.props.addServiceHandler}
                            inputText={this.props.inputText}
                            error={false}
                            inlineResults={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./scripts/components/ModalServices.jsx